import React, { Component } from 'react'
import styled from 'styled-components'

import theme from 'ui/styles/theme'

const getDegrees = (direction) => {
  switch (direction) {
    case 'left':
      return -90
    case 'right':
      return 90;
    case 'down':
      return 180
    default:
      return 0
  }
}

const Wrapper = styled.svg`
  transform-origin: center;
  transform: rotate(${props => getDegrees(props.direction)}deg);


  path, circle {
    transition: all 500ms;
    transform-origin: center;
  }

  &:hover {
    path {
      transform: translateY(4px);
    }

    circle {
      transform: scale(0.9, 0.9);
      opacity: 0.1;
    }
  }
`

export default class CircleArrow extends Component {
  render() {
    const { color, direction, ...rest } = this.props

    const foregroundColor = color || theme.colors.secondary

    return (
      <Wrapper
        direction={direction}
        {...rest}
        width="67"
        height="66"
        viewBox="0 0 67 66"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g transform="rotate(-180 33 33)" fill="none" fillRule="evenodd">
          <path d="M43.55 35.55L32.5 46.6 21.45 35.55M32.1 46.8V17.55" stroke={foregroundColor} />
        </g>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/generic/CircleArrow.js